// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a2637df2","732":"b8981cef","977":"ed50e57e"}[chunkId] + ".chunk.js";
};